import React, { useEffect, useState } from "react";
import { Grid, Typography, Paper, Chip } from "@mui/material";
import { getCustomerPigmyDetailService } from "../../../../services/pigmyService";
import useStore from "../../../../useStore";
import moment from "moment";

function CustomerPigmyDetails() {
  const { pigmyId } = useStore();
  const [pigmyDetails, setPigmyDetails] = useState({});

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const response = await getCustomerPigmyDetailService(pigmyId);
        console.log(response);
        setPigmyDetails(response);
      } catch (error) {
        console.error("Failed to fetch pigmy details:", error);
      }
    };

    fetchDetails();
  }, [pigmyId]);

  const details = [
    { label: "Pigmy Code", value: pigmyDetails?.pigmyCode },
    { label: "Agent Name", value: pigmyDetails?.agent?.userName },
    { label: "Frequency", value: pigmyDetails?.frequency },
    {
      label: "Total Received Amount",
      value: pigmyDetails?.totalReceivedAmount || 0,
    },
    {
      label: "Total Withdrawn Amount",
      value: pigmyDetails?.totalWithdrawAmount || 0,
    },
    {
      label: "Start Date",
      value: pigmyDetails?.startDate
        ? moment(pigmyDetails?.startDate).format("DD-MM-YYYY")
        : "",
    },
    {
      label: "End Date",
      value: pigmyDetails?.endDate
        ? moment(pigmyDetails?.endDate).format("DD-MM-YYYY")
        : "",
    },
    {
      label: "Status",
      value: pigmyDetails?.status,
    },
  ];

  return (
    <Paper
      elevation={3}
      sx={{
        padding: "20px",
        borderRadius: "12px",
        backgroundColor: "#f9f9f9",
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Grid container spacing={3}>
        {details.map((item, index) => (
          <Grid item xs={12} sm={3} key={index}>
            <Typography
              variant="body2"
              sx={{ fontWeight: "bold", color: "#555" }}
            >
              {item.label}
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: "#333", marginTop: "4px" }}
            >
              {item.label === "Status" ? (
                <Chip
                  label={item.value || "N/A"}
                  sx={{
                    bgcolor:
                      item.value === "Active"
                        ? "green"
                        : item.value === "Inactive"
                        ? "red"
                        : "grey",
                    color: "white",
                  }}
                />
              ) : (
                item.value || "N/A"
              )}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
}

export default CustomerPigmyDetails;
